module.exports = __webpack_public_path__ + "img/141.e3a118fa.jpg";